import { showDeleteConfirmation } from '@modules/common';
import { BaseBloc } from '@core/utils/bloc';
import { Repository } from '@core/utils/repository';
import { handleMessage, requestMessage } from '@business/messages';
import { CopyTemplateRequest, BlockTemplateResponse } from '@business/entities/proposal';
import { ProposalTemplateAPI } from '@business/api/proposal_template_api';
import { switchMap } from 'rxjs/operators';

export class BlockTemplateBloc extends BaseBloc {
  private readonly templatesRepo = new Repository<BlockTemplateResponse>({
    getItemId: item => item.id,
  });

  readonly templates$ = this.templatesRepo.items$;
  readonly selectItem = this.templatesRepo.selectItem;

  onReset() {
    this.templatesRepo.reset();
  }

  fetchTemplates = (type: string) => {
    return ProposalTemplateAPI.fetchBlockTemplates(type).pipe(
      this.templatesRepo.ops.reset(),
      handleMessage({ error: requestMessage('fetch_proposal_template_error') }),
    );
  };

  deleteTemplate = (id: string) => {
    return showDeleteConfirmation('Delete Template', `Do you really want to remove this template?`).pipe(
      switchMap(() => ProposalTemplateAPI.deleteBlockTemplate(id)),
      this.templatesRepo.ops.removeOne(() => id),
      handleMessage({
        type: requestMessage('delete_proposal_template'),
      }),
    );
  };

  copyBlockTemplate = (data: CopyTemplateRequest) => {
    return ProposalTemplateAPI.copyBlockTemplate(data).pipe(
      handleMessage({
        type: requestMessage('copy_proposal_template_block'),
      }),
    );
  };
}
